<button (click)="toggleMenu()" class="hamburger">
  <span class="menu-{{menuState}}">toggle menu</span>
</button>
<top-menu [@slideInOut]="menuState"></top-menu>

<router-outlet></router-outlet>
